import {
  BannerOffer,
  ComparativeTable,
  Doubts,
  DynamicFaq,
  ExperienceCalibrator,
  Faq,
  FluencyJourney,
  FluencyWeekHero,
  FreeClassesInfo,
  Hero,
  HeroWithBullets,
  LearnTrack,
  MediaPress,
  Method,
  Overview,
  PartnerHero,
  Plans,
  PlansTestimonies,
  TechHero,
  TechJourney,
  Warranty,
  WhoIs,
} from 'templates/PlansTemplate/imports';

export default function ComponentsMap({
  comparativeTable,
  componentsOrder,
  cp,
  dynamicFaqText,
  dynamicFaqTopics,
  freeClasses,
  heroData,
  learnTrack,
  methodTitle,
  openWidget,
  plans,
  plansData,
  techJourney,
  techOverview,
  testimonies,
  warranty,
  whoIs,
}) {
  const componentsMap = new Map([
    ['FluencyWeek', <FluencyWeekHero key="FluencyWeek" heroData={heroData} />],
    ['HeroComponent', <Hero key="HeroComponent" heroData={heroData} />],
    [
      'Hero2Component',
      <HeroWithBullets key="Hero2Component" heroData={heroData} />,
    ],
    ['PartnerHero', <PartnerHero key="PartnerHero" heroData={heroData} />],
    ['MediaPressComponent', <MediaPress key="MediaPressComponent" />],
    [
      'PlansComponent',
      <Plans
        content={plansData}
        cp={cp}
        key="PlansComponent"
        openWidget={openWidget}
        plans={plans}
      />,
    ],
    [
      'MethodComponent',
      <Method key="MethodComponent" methodTitle={methodTitle} />,
    ],
    ['FluencyJourney', <FluencyJourney key="FluencyJourney" hideCTA />],
    [
      'ExperienceCalibratorComponent',
      <ExperienceCalibrator key="ExperienceCalibratorComponent" />,
    ],
    [
      'PlansTestimoniesComponent',
      <PlansTestimonies
        key="PlansTestimoniesComponent"
        content={testimonies}
      />,
    ],
    ['FaqComponent', <Faq key="FaqComponent" />],
    [
      'DynamicFaqComponent',
      <DynamicFaq
        dynamicFaqText={dynamicFaqText}
        dynamicFaqTopics={dynamicFaqTopics}
        key="DynamicFaqComponent"
      />,
    ],
    [
      'ComparativeTableComponent',
      <ComparativeTable
        content={comparativeTable}
        key="ComparativeTableComponent"
      />,
    ],
    ['BannerOfferComponent', <BannerOffer key="BannerOfferComponent" />],
    [
      'FreeClasses',
      <FreeClassesInfo key="FreeClassesComponent" {...freeClasses} />,
    ],
    ['Doubts', <Doubts key="Doubts" />],
    ['LearnTrack', <LearnTrack key="LearnTrack" content={learnTrack} />],
    ['TechHero', <TechHero key="TechHero" />],
    ['TechJourney', <TechJourney key="TechJourney" content={techJourney} />],
    ['TechOverview', <Overview key="TechOverview" content={techOverview} />],
    ['Warranty', <Warranty key="Warranty" content={warranty} />],
    ['WhoIs', <WhoIs key="WhoIs" content={whoIs} />],
  ]);

  return componentsOrder?.length > 0
    ? componentsOrder.map((Component) => componentsMap.get(Component))
    : null;
}
